var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "y-tree-menu" },
    [
      _c(
        "div",
        { staticClass: "y-label-wrapper", on: { click: _vm.toggleChildren } },
        [
          _c("div", { class: _vm.labelClasses, attrs: { depth: _vm.depth } }, [
            _c("div", { staticClass: "y-label-text" }, [
              _c(
                "a",
                {
                  class: _vm.isActive,
                  attrs: { href: "/products/" + _vm.slug + "/" },
                  on: { click: _vm.updateScroll },
                },
                [_vm._v(_vm._s(_vm.name))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.children
            ? _c("span", { staticClass: "y-cat-icons", class: _vm.iconClasses })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.children, function (child) {
        return _vm.showChildren
          ? _c("tree-menu", {
              key: child.name,
              attrs: {
                children: child.children,
                name: child.name,
                slug: child.full_slug,
                depth: _vm.depth + 1,
              },
            })
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }